import {
	legendaInfoDesvioMilimetro,
	legendaInfoDesvioPorcentagem,
	legendaInfoPluvObservada2MesesAAnual,
	legendaInfoPluvObservadaPeriodo,
} from '@componentes/mapa-paraiba-svg/legenda';
import {
	BalancoHidricoArmCores,
	BalancoHidricoDefCores,
	DesvioMilimetroCores,
	DesvioPorcentagemCores,
	PluviometriaObservadaCoresInterpolada,
} from '@modulos/home/submodulos/dados-meteorologicos/enum/variaveis-meteorologicas-enum';

import colormap from 'colormap';

const cm: string[] = colormap({
	colormap: 'rainbow',
	nshades: 27,
	format: 'hex',
	alpha: 1,
});

const desvioAcumuladoColormap: string[] = colormap({
	colormap: 'rainbow',
	nshades: 40,
	format: 'hex',
	alpha: 1,
});

const precipitacaoCoresDiasChuva = colormap({
	colormap: [
		{ index: 0, rgb: [255, 255, 255, 1] }, // 9
		{ index: 0.1, rgb: [253, 26, 19, 1] }, // 8
		{ index: 0.2, rgb: [255, 122, 51] }, // 7
		{ index: 0.3, rgb: [255, 218, 51, 1] }, // 6
		{ index: 0.4, rgb: [129, 255, 111, 1] }, // 5
		{ index: 0.5, rgb: [65, 205, 221, 1] }, // 4
		{ index: 0.6, rgb: [51, 173, 255, 1] }, // 3
		{ index: 0.7, rgb: [41, 48, 207, 1] }, // 2
		{ index: 0.8, rgb: [51, 132, 255, 1] }, // 1
	],
	nshades: 9,
	format: 'hex',
	alpha: 0,
});

const precipitacaoColormap = Object.values(
	PluviometriaObservadaCoresInterpolada
);
const desvioMilimetroColormap = Object.values(DesvioMilimetroCores);
const desvioPorcentagemColormap = Object.values(DesvioPorcentagemCores);

const balancoHidricoDefColormap = Object.values(BalancoHidricoDefCores);
const balancoHidricoArmColormap = Object.values(BalancoHidricoArmCores);

const climatologiaColormap = colormap({
	colormap: [
		{ index: 0, rgb: [249, 53, 55, 1] }, // vermelho
		{ index: 0.1, rgb: [255, 95, 53, 1] }, // laranja
		{ index: 0.2, rgb: [252, 169, 116, 1] }, // salmão
		{ index: 0.3, rgb: [252, 204, 155, 1] }, // laranja pastel
		{ index: 0.4, rgb: [253, 254, 153, 1] }, // amarelo
		{ index: 0.5, rgb: [155, 253, 1, 1] }, // verde 1
		{ index: 0.6, rgb: [115, 217, 115, 1] }, // verde 2
		{ index: 0.7, rgb: [50, 205, 49, 1] }, //verde 3
		{ index: 0.8, rgb: [0, 154, 55, 1] }, // verde 4
		{ index: 0.9, rgb: [50, 93, 92, 1] }, // verde 5
	],

	nshades: 12,
	format: 'hex',
	alpha: 0,
});
const climatologiaMesesColormap = colormap({
	colormap: [
		{ index: 0.0, rgb: [249, 53, 55, 1] }, // #F93537
		{ index: 0.09, rgb: [255, 95, 53, 1] }, // #FF5F35
		{ index: 0.18, rgb: [252, 169, 116, 1] }, // #FCA974
		{ index: 0.27, rgb: [252, 204, 155, 1] }, // #FCCC9B
		{ index: 0.36, rgb: [253, 254, 153, 1] }, // #FDFE99
		{ index: 0.45, rgb: [204, 254, 77, 1] }, // #CCFE4D
		{ index: 0.54, rgb: [155, 253, 1, 1] }, // #9BFD01
		{ index: 0.63, rgb: [115, 217, 115, 1] }, // #73D973
		{ index: 0.72, rgb: [50, 205, 49, 1] }, // #32CD31
		{ index: 0.81, rgb: [0, 154, 55, 1] }, // #009A37
		{ index: 0.9, rgb: [84, 130, 53, 1] }, // #548235
		{ index: 1.0, rgb: [56, 87, 35, 1] }, // #385723
	],
	nshades: 12,
	format: 'hex',
	alpha: 0,
});

const climatologiaAnoColormap = colormap({
	colormap: [
		{ index: 0.0, rgb: [255, 0, 0] }, // 400
		{ index: 0.07, rgb: [255, 85, 0] }, // 500
		{ index: 0.14, rgb: [255, 136, 0] }, // 600
		{ index: 0.21, rgb: [255, 178, 102] }, // 700
		{ index: 0.28, rgb: [255, 238, 102] }, // 800
		{ index: 0.35, rgb: [221, 255, 51] }, // 900
		{ index: 0.42, rgb: [170, 255, 0] }, // 1000
		{ index: 0.49, rgb: [85, 221, 0] }, // 1100
		{ index: 0.56, rgb: [0, 170, 0] }, // 1200
		{ index: 0.63, rgb: [0, 128, 128] }, // 1300
		{ index: 0.7, rgb: [102, 136, 255] }, // 1400
		{ index: 0.77, rgb: [51, 102, 255] }, // 1500
		{ index: 0.84, rgb: [0, 51, 255] }, // 1600
		{ index: 0.91, rgb: [0, 0, 200] }, // 1700
		{ index: 0.98, rgb: [0, 0, 150] }, // 1800
		{ index: 1.0, rgb: [75, 32, 75] }, // ≥1900 (roxo escuro)
	],
	nshades: 16,
	format: 'hex',
	alpha: 1,
});

const IAPMColormap = colormap({
	colormap: [
		{ index: 0, rgb: [255, 0, 0] }, // vermelho
		{ index: 0.16, rgb: [255, 152, 0] }, // laranja
		{ index: 0.333, rgb: [255, 234, 0] }, // amarelo
		{ index: 0.5, rgb: [153, 255, 0] }, // verde 1
		{ index: 0.666, rgb: [0, 255, 68] }, // verde 2
		{ index: 0.833, rgb: [0, 152, 255] }, //azul
	],

	nshades: 7,
	format: 'hex',
	alpha: 1,
});

const pluviometriaIntervalos1Mes = Object.keys(
	legendaInfoPluvObservadaPeriodo
).map(Number);
pluviometriaIntervalos1Mes.sort((a, b) => a - b);

const pluviometriaIntervalos2MesesAAnual = Object.keys(
	legendaInfoPluvObservada2MesesAAnual
).map(Number);
pluviometriaIntervalos2MesesAAnual.sort((a, b) => a - b);

const desvioMilimetroIntervalos = Object.keys(legendaInfoDesvioMilimetro).map(
	Number
);
desvioMilimetroIntervalos.sort((a, b) => a - b);

const desvioPorcentagemIntervalos = Object.keys(
	legendaInfoDesvioPorcentagem
).map(Number);
desvioPorcentagemIntervalos.sort((a, b) => a - b);

export interface ParametrosVariavel {
	model: 'exponential' | 'gaussian' | 'spherical';
	sigma2: number;
	alpha: number;
	unidade: string;
	colormap: string[];
	valorMin: number;
	valorMax: number;
	intervalos: number[];
	infoAdicional: string[];
}

export type VariavelMeteorologica =
	| 'temperatura'
	| 'umidade'
	| 'precipitacao1Mes'
	| 'precipitacao2MesesAAnual'
	| 'mrai'
	| 'desvioAcumulado'
	| 'desvioMilimetro'
	| 'desvioPorcentagem'
	| 'pressao'
	| 'temperaturaSolo'
	| 'climatologiaMes'
	| 'climatologiaTrimestral'
	| 'climatologiaQuadra'
	| 'climatologiaSemestral'
	| 'climatologiaAno'
	| 'precipitacao_dias_chuva'
	| 'deficienciaHidrica'
	| 'armazenamentoSolo';

export const variavelParametros = {
	temperatura: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 15,
		valorMax: 38,
		intervalos: [0, 12, 16, 18, 20, 22, 24, 26, 28, 30, 33, 35, 40],
		unidade: '°C',
		colormap: colormap({
			colormap: 'rainbow',
			nshades: 14,
			format: 'hex',
			alpha: 1,
		}).filter((_e, i) => i !== 1 && i !== 2),
		infoAdicional: [],
	},
	umidade: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 0,
		valorMax: 100,
		intervalos: [10, 20, 30, 40, 50, 60, 70, 80, 90],
		unidade: '%',
		colormap: colormap({
			colormap: 'rainbow',
			nshades: 14,
			format: 'hex',
			alpha: 1,
		})
			.filter((_e, i) => i > 3 && i !== 7)
			.reverse(),
		infoAdicional: [],
	},
	precipitacao1Mes: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 400,
		valorMin: 9.9,
		intervalos: pluviometriaIntervalos1Mes,
		unidade: 'mm',
		colormap: precipitacaoColormap,
		infoAdicional: [],
	},
	precipitacao: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 400,
		valorMin: 9.9,
		intervalos: pluviometriaIntervalos1Mes,
		unidade: 'mm',
		colormap: precipitacaoColormap,
		infoAdicional: [],
	},
	precipitacao2MesesAAnual: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 1600,
		valorMin: 199,
		intervalos: pluviometriaIntervalos2MesesAAnual,
		unidade: 'mm',
		colormap: precipitacaoColormap,
		infoAdicional: [],
	},
	precipitacao_dias_chuva: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 35,
		valorMin: 0,
		intervalos: [0, 5, 10, 15, 20, 25, 30, 35],
		unidade: 'dias',
		colormap: precipitacaoCoresDiasChuva,
		infoAdicional: [],
	},
	mrai: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 10,
		valorMin: -10,
		intervalos: [-10, -4, -2, 0, 2, 4, 10],
		unidade: '',
		colormap: IAPMColormap,
		infoAdicional: [
			'Extremamente seco',
			'Muito seco',
			'Seco',
			'Úmido',
			'Muito úmido',
			'Extremamente úmido',
		],
	},
	desvioAcumulado: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 100,
		valorMin: -100,
		intervalos: [-100, -50, -20, -10, -5, 20, 30, 50, 100],
		unidade: '%',
		colormap: desvioAcumuladoColormap
			.filter((_e, i) => i >= 8)
			.reverse()
			.filter(
				(_e, i) => ![4, 6, 7, 9, 11, 12, 13, 14, 15, 16, 17, 18].includes(i)
			)
			.slice(4, 13),
		infoAdicional: [],
	},
	desvioMilimetro: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 200,
		valorMin: -300,
		intervalos: desvioMilimetroIntervalos,
		unidade: 'mm',
		colormap: desvioMilimetroColormap,
		infoAdicional: [],
	},
	desvioPorcentagem: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMax: 125,
		valorMin: -100,
		intervalos: desvioPorcentagemIntervalos,
		unidade: '%',
		colormap: desvioPorcentagemColormap,
		infoAdicional: [],
	},
	pressao: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: null,
		valorMax: null,
		intervalos: [900, 912, 924, 936, 948, 961, 973, 985, 997, 1010],
		unidade: 'hPa',
		colormap: cm
			.filter((_e, i) => ![0, 1, 2, 3, 4, 5, 6, 7].includes(i))
			.filter((_e, i) => i % 2 === 0),
		infoAdicional: [],
	},
	temperaturaSolo: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 15,
		valorMax: 38,
		intervalos: [0, 12, 16, 18, 20, 22, 24, 26, 28, 30, 33, 35, 40],
		unidade: '°C',
		colormap: colormap({
			colormap: 'rainbow',
			nshades: 14,
			format: 'hex',
			alpha: 1,
		}).filter((_e, i) => i !== 1 && i !== 2),
		infoAdicional: [],
	},
	climatologiaMes: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 0,
		valorMax: 350,
		intervalos: [0, 10, 25, 50, 75, 100, 150, 200, 250, 300, 350],
		unidade: 'mm',
		colormap: climatologiaColormap,
		infoAdicional: [],
	},
	climatologiaTrimestral: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 0,
		valorMax: 800,
		intervalos: [0, 50, 100, 150, 200, 250, 300, 400, 500, 600, 700, 800],
		unidade: 'mm',
		colormap: climatologiaMesesColormap,
		infoAdicional: [],
	},

	climatologiaQuadra: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 0,
		valorMax: 800,
		intervalos: [0, 50, 100, 150, 200, 250, 300, 400, 500, 600, 700, 800],
		unidade: 'mm',
		colormap: climatologiaMesesColormap,
		infoAdicional: [],
	},
	climatologiaSemestral: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 0,
		valorMax: 1800,
		intervalos: [
			300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500,
			1600, 1700, 1800, 1900,
		],
		unidade: 'mm',
		colormap: climatologiaAnoColormap,
		infoAdicional: [],
	},

	climatologiaAno: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 400,
		valorMax: 1900,
		intervalos: [
			300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500,
			1600, 1700, 1800, 1900,
		],
		unidade: 'mm',
		colormap: climatologiaAnoColormap, // 16 cores
	},
	deficienciaHidrica: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: -200,
		valorMax: 0,
		intervalos: [-200, -150, -100, -75, -50, -30, -15, -10, -5, 0],
		unidade: 'mm',
		colormap: balancoHidricoDefColormap,
		infoAdicional: [
			'Extremamente crítica',
			'Crítica severa',
			'Crítica',
			'Muito severa',
			'Severa',
			'Alta',
			'Moderada',
			'Baixa',
			'Muito baixa',
			'Sem deficiência',
		],
	},
	armazenamentoSolo: {
		model: 'exponential',
		sigma2: 0,
		alpha: 100,
		valorMin: 0,
		valorMax: 150,
		intervalos: [0, 15, 50, 90, 130, 150],
		unidade: 'mm',
		colormap: balancoHidricoArmColormap,
		infoAdicional: [
			'Seco',
			'Baixo',
			'Moderado',
			'Alto',
			'Muito alto',
			'Saturado',
		],
	},
};
